module.exports = __webpack_public_path__ + "img/sj-blue.99680df5.svg";